<script lang="ts">
    import { LOGIN_PAGE_URL, REGISTER_PAGE_URL } from "@/constants";
    import type NudgesEntity from "@modules/nudges/entities/NudgesEntity";

    import BaseButton from "@components/Buttons/BaseButton.svelte";

    import { nudgesCustomerRewardsState } from "../state/nudgesCustomerRewardsState";

    export let nudges: NudgesEntity;

    const SIGNUP = "signup";
    const LOGIN = "login";

    const {
        nudgesService,
        NudgesPopUpWidgetVisibilityManager,
        locationController,
    } = nudgesCustomerRewardsState();

    const handleAddView = (type: string) => {
        nudgesService.addAction({
            nudgeId: nudges.nudge.id,
        });
        nudgesService.addViewed({
            nudgeId: nudges.nudge.id,
        });
        NudgesPopUpWidgetVisibilityManager.nudgesPopUpWidgetHide();

        if (type === SIGNUP) {
            locationController.goTo(
                nudges.template.ctaw.signUpLink || REGISTER_PAGE_URL
            );
        } else {
            locationController.goTo(
                nudges.template.ctaw.loginLink || LOGIN_PAGE_URL
            );
        }
    };
</script>

<BaseButton
    class="gw-nudges-modal__active-button"
    on:click={() => handleAddView(SIGNUP)}
    >{nudges.template.ctaw.signUpText}</BaseButton
>
<BaseButton
    class="gw-nudges-modal__base-button"
    on:click={() => handleAddView(LOGIN)}
    >{nudges.template.ctaw.loginText}</BaseButton
>
